import { useMemo } from "react";

import PantographMatrix from "../PantographMatrix";
import buildPantographMatrixData from "../builders/buildPantographMatrixData";

export default function PantographSection({
    pantografosMonitor
}) {

    const matrixData = useMemo(
        () => buildPantographMatrixData(pantografosMonitor),
        [pantografosMonitor]
    );

    return (
        <PantographMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Pantógrafo"
            matrixData={matrixData}
        />
    );
}